<template>
  <v-row>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-col>
          <v-btn
            v-show="type == 'color'"
            :color="(!backgroundColor ? 'primary' : backgroundColor)"
            class="mr-0 mt-1 px-1 float-end"
            min-width="40"
            style="padding: 12px 22px !important;"
            v-bind="attrs"
            v-on="on"
          />
          <v-img
            v-show="type == 'image' && backgroundImage"
            width="43"
            max-width="43"
            :src="backgroundImage"
            aspect-ratio="1"
            class="grey lighten-2 float-end"
            style="border-radius: 5px"
            v-bind="attrs"
            v-on="on"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>
        </v-col>
      </template>
      <v-card>
        <v-row class="mx-0">
          <v-col>
            <v-radio-group
              v-model="type"
              class="mt-2 mb-3"
              hide-details
              row
            >
              <v-radio
                :label="$t('gallery')"
                value="image"
              />
              <v-radio
                :label="$t('color')"
                value="color"
              />
            </v-radio-group>
          </v-col>
        </v-row>
        <v-divider />
        <v-card-text>
          <v-row
            v-show="type == 'image'"
            style="height: 300px;overflow-y: auto"
          >
            <v-item-group
              v-model="selected"
              mandatory
            >
              <v-container>
                <v-row>
                  <v-col
                    v-for="(image, i) in images"
                    :key="i"
                    cols="12"
                    class="pa-1"
                    md="4"
                    @click="selectImage(image)"
                  >
                    <v-item v-slot="{ active, toggle }">
                      <v-img
                        :color="active ? 'primary' : ''"
                        :src="image.link"
                        :lazy-src="image.link"
                        aspect-ratio="1"
                        style="border-radius: 5px;cursor: pointer"
                        height="144"
                        class="grey lighten-2"
                        @click="toggle"
                      >
                        <v-fade-transition>
                          <div
                            v-if="active"
                            style="background-color: #fff;height: 144px;opacity:0.8"
                            class="text-h2 flex-grow-1 text-center"
                          >
                            <v-icon
                              style="margin-top: 53px;"
                              color="green"
                              large
                            >
                              mdi-check-circle-outline
                            </v-icon>
                          </div>
                        </v-fade-transition>
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            />
                          </v-row>
                        </template>
                      </v-img>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-row>
          <v-row v-if="type == 'color'">
            <v-color-picker
              v-if="render"
              v-model="selectedColor"
              dot-size="25"
              hide-canvas
              hide-inputs
              hide-mode-switch
              hide-sliders
              mode="hexa"
              show-swatches
              width="100%"
              @input="selectColor"
              swatches-max-height="132"
            />
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// Mixins
  import General from '../../../../Mixins/general'
  import store from '@/store'
  export default {
    name: 'Background',
    components: {
    },
    mixins: [General],
    data: () => ({
      render: false,
      dialog: false,
      selected: null,
      select: 'setBackgroundStyle',
      selectedColor: null,
      backgroundColor: '#e7e7e7',
      backgroundImage: '/img/background/login.jpg',
      images: [
        {
          image: '/img/background/lock.jpg',
          link: '/img/background/lock.jpg',
        },
        {
          image: '/img/background/login.jpg',
          link: '/img/background/login.jpg',
        },
        {
          image: '/img/background/1.jpg',
          link: '/img/background/1.jpg',
        },
        {
          image: '/img/background/2.jpg',
          link: '/img/background/2.jpg',
        },
        {
          image: '/img/background/3.jpg',
          link: '/img/background/3.jpg',
        },
        {
          image: '/img/background/4.jpg',
          link: '/img/background/4.jpg',
        },
        {
          image: '/img/background/5.jpg',
          link: '/img/background/5.jpg',
        },
        {
          image: '/img/background/6.jpg',
          link: '/img/background/6.jpg',
        },
        {
          image: '/img/background/7.jpg',
          link: '/img/background/7.jpg',
        },
        {
          image: '/img/background/8.jpg',
          link: '/img/background/8.jpg',
        },
        {
          image: '/img/background/9.jpg',
          link: '/img/background/9.jpg',
        },
        {
          image: '/img/background/10.jpg',
          link: '/img/background/10.jpg',
        },
        {
          image: '/img/background/11.jpg',
          link: '/img/background/11.jpg',
        },
      ],
      type: 'image',
    }),
    watch: {
      backgroundColor (val) {
      },
    },
    beforeMount () {
      var store = this.$store.state
      this.backgroundColor = store.backgroundColor
      this.backgroundImage = store.backgroundImage
      if (this.backgroundImage) {
        this.type = 'image'
        var index = this.images.findIndex(x => x.image === this.backgroundImage)
        if (index !== -1) {
          this.selected = index
        }
      }
      if (this.backgroundColor && !this.backgroundImage) {
        this.type = 'color'
      }
      if (!this.backgroundColor && !this.backgroundImage) {
        this.type = 'image'
        this.backgroundImage = '/img/background/lock.jpg'
      }
      this.render = true
    },
    mounted () {
    },
    methods: {
      selectColor () {
        if (!this.render && !this.selectedColor && !this.selectedColor.hex) return false
        var val = this.selectedColor.hex
        var storage = JSON.parse(localStorage.getItem('token'))
        if (val) {
          this.backgroundColor = val
          this.backgroundImage = null
          storage.init.backgroundColor = val
          storage.init.backgroundImage = null
          store.commit('SET_BACKGROUNDCOLOR', val)
          store.commit('SET_BACKGROUNDIMAGE', null)
          localStorage.setItem('token', JSON.stringify(storage))
          this.store()
        } else {
          this.backgroundColor = null
          storage.init.backgroundColor = null
          localStorage.setItem('token', JSON.stringify(storage))
          store.commit('SET_BACKGROUNDCOLOR', null)
        }
      },
      selectImage (item) {
        if (!this.render) return false
        if (item) {
          this.backgroundColor = null
          this.backgroundImage = item.image
          var storage = JSON.parse(localStorage.getItem('token'))
          // storage.init.backgroundColor = null
          storage.init.backgroundImage = item.image
          store.commit('SET_BACKGROUNDCOLOR', null)
          store.commit('SET_BACKGROUNDIMAGE', item.image)
          localStorage.setItem('token', JSON.stringify(storage))
          this.store()
        }
      },
      store () {
        var app = this
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
      },
    },
  }
</script>

<style lang="sass">
</style>
